<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */
import { useMainStore } from "@/store/main/index";
import type { SecondaryDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

defineProps<{
  contentData: SecondaryDataInterface;
}>();

const mainStore = useMainStore();
</script>

<template>
  <section v-if="mainStore?.windowWidth > 983" class="parallax pos-rel">
    <div class="container">
      <div class="parallax__image pos-rel ov-hidden">
        <Picture
          :devices="contentData?.data?.list?.[0]?.image?.[0]?.devices"
          :parallax="true"
          :alt="contentData?.data?.list?.[0]?.title"
          class="parallax__image-picture"
          imgClass="img-absolute"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.parallax {
  .container {
    padding: 320px 320px 0px 320px;
    @include maxq(desktop-2k) {
      padding: 220px 213px 0px 213px;
    }
    @include maxq(desktop-lg) {
      padding: 160px 160px 0px 160px;
    }
    @include maxq(desktop) {
      padding: 118px 118px 0px 118px;
    }
    @include maxq(desktop-sm) {
      padding: 104px 50px 0px 50px;
    }
  }
  &__image {
    z-index: 2;
    height: 0px;
    padding-top: calc(100% / (2860 / 1264));
    @include maxq(desktop-2k) {
      padding-top: calc(100% / (1908 / 843));
    }
    @include maxq(desktop-lg) {
      padding-top: calc(100% / (1430 / 632));
    }
    @include maxq(desktop) {
      padding-top: calc(100% / (1034 / 512));
    }
    @include maxq(desktop-sm) {
      padding-top: calc(100% / (884 / 448));
    }
    img {
      height: 132%;
      top: -16%;
      @include maxq(desktop-lg) {
        height: 123%;
        top: -12%;
      }
      left: 0;
      object-fit: cover;
      @include maxq(tablet) {
        height: 145%;
        top: -22.5%;
      }
    }
  }
}
</style>
